import React from 'react';

import { WarningTriangle } from '@videoblocks/react-icons';

import ReportErrorModal from '../ReportErrorModal';

const ReportErrorButton = ({
  stockItemId,
  color = 'white',
}: {
  stockItemId: number;
  color?: 'white' | 'black';
}) => (
  <ReportErrorModal stockItemId={stockItemId}>
    {(openModal) => (
      <div className="flex gap-x-2">
        <WarningTriangle className={`w-4 fill-current text-${color}`} />
        <button
          className="text-sm bg-transparent border-none"
          id="report-error-button"
          onClick={openModal}
        >
          Report an Error
        </button>
      </div>
    )}
  </ReportErrorModal>
);

export default ReportErrorButton;
